import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import './App.css';
import { BackgroundCycler } from './components/background/BackgroundCycler';
import { ThemeComponent } from './components/base/styles/Theme';
import { TutorialTracker } from './components/base/tutorial/tutorialTracker/TutorialTracker';
import { CreateTeamComponent } from './components/create-team/CreateTeam';
import { AnimatedDiv } from './components/MotionMui/MotionMui';
import { Options } from './components/options/Options';
import { SignInFlow } from './components/sign-in/SignInFlow';
import { TeamBase } from './components/team/TeamBase';
import { VisibilityProvider } from './context/VisibilityContext';
import { PopupOnOverlayContextComponent } from './components/base/overlay/PopupOnOverlay';

function App() {
  return (
    <Router>
      <AnimatedDiv root>
        <BackgroundCycler />
        {/* We are getting more default contextrs, might want to put them in their own collating component */}
        <VisibilityProvider>
          <ThemeComponent>
            <PopupOnOverlayContextComponent>
              <Switch>
                <Route exact path="/">
                  <SignInFlow />
                </Route>
                <TutorialTracker>
                  <Route path="/options" component={Options} />
                  <Route path="/teams*">
                    <Switch>
                      <Route exact path="/teams">
                        <CreateTeamComponent />
                      </Route>
                      <Route path="/teams/:teamId" component={TeamBase} />
                    </Switch>
                  </Route>
                </TutorialTracker>
              </Switch>
            </PopupOnOverlayContextComponent>
          </ThemeComponent>
        </VisibilityProvider>
      </AnimatedDiv>
    </Router>
  );
}

export default App;
